/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  OpenBloxL2,
  OpenBloxL2Interface,
} from "../../../../contracts/token/OpenBlox/OpenBloxL2";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_l2Gateway",
        type: "address",
      },
      {
        internalType: "address",
        name: "_l1TokenAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "tokendata",
        type: "bytes",
      },
    ],
    name: "bridgeBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "tokendata",
        type: "bytes",
      },
    ],
    name: "bridgeMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burnBlox",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getBlox",
    outputs: [
      {
        internalType: "uint256",
        name: "genes",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "bornAt",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "generation",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "parent0Id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "parent1Id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ancestorCode",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "reproduction",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "increaseReproduction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "l1Address",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "l2Gateway",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "genes",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "bornAt",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "generation",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "parent0Id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "parent1Id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ancestorCode",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "reproduction",
        type: "uint8",
      },
    ],
    name: "mintBlox",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type OpenBloxL2ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: OpenBloxL2ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class OpenBloxL2__factory extends ContractFactory {
  constructor(...args: OpenBloxL2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _l2Gateway: PromiseOrValue<string>,
    _l1TokenAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<OpenBloxL2> {
    return super.deploy(
      _l2Gateway,
      _l1TokenAddress,
      overrides || {}
    ) as Promise<OpenBloxL2>;
  }
  override getDeployTransaction(
    _l2Gateway: PromiseOrValue<string>,
    _l1TokenAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _l2Gateway,
      _l1TokenAddress,
      overrides || {}
    );
  }
  override attach(address: string): OpenBloxL2 {
    return super.attach(address) as OpenBloxL2;
  }
  override connect(signer: Signer): OpenBloxL2__factory {
    return super.connect(signer) as OpenBloxL2__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): OpenBloxL2Interface {
    return new utils.Interface(_abi) as OpenBloxL2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OpenBloxL2 {
    return new Contract(address, _abi, signerOrProvider) as OpenBloxL2;
  }
}
